const initCartRemove = () => {
  const buttons = document.querySelectorAll('[data-cart-remove]');

  buttons.forEach((button) => {
    button.addEventListener('click', async () => {
      const item = button.closest('[data-cart-item]');
      if (!item) {
        return;
      }
      const body = new URLSearchParams({
        action: 'remove_cart_item',
        nonce: wooSettings.removeCartNonce,
        cart_item_key: item.dataset.cartItemKey,
      });
      button.disabled = true;
      item.classList.add('is-loading');
      try {
        const response = await fetch(wooSettings.ajaxUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          credentials: 'same-origin',
          body,
        });
        const result = await response.json();
        if (!result.success) {
          throw new Error('Не удалось удалить товар');
        }
        document.querySelectorAll('.header__cart-value').forEach((counter) => {
          counter.textContent = result.data.cartCount;
        });
        if (result.data.cartEmpty) {
          window.location.reload();
          return;
        }
        item.closest('li')?.remove();
      } catch (error) {
        button.disabled = false;
        item.classList.remove('is-loading');
        console.error(error);
      }
    });
  });
};

export {initCartRemove};